import { CtaButton, Grid, Logo } from '@zappyrent/hundop';
import { I18nextContext, useTranslation } from 'gatsby-plugin-react-i18next';
import React, { useContext } from 'react';

import useUtmQueryString from '../../../hooks/useUtmQueryString';
import { StyledHeader, StyledLogoWrapper } from './ReferALandlordHeader.styles';

const ReferALandlordHeader = (): JSX.Element => {
  const { language } = useContext(I18nextContext);
  const { t } = useTranslation(['navigation']);
  const utmQueryString = useUtmQueryString('referral');

  return (
    <StyledHeader>
      <Grid container justifyContent="space-between" alignItems="center">
        <StyledLogoWrapper>
          <a href={`/${language}`} title="Zappyrent">
            <Logo user="landlord" />
          </a>
        </StyledLogoWrapper>
        <div>
          <CtaButton
            href={`${process.env.GATSBY_REFERRAL_PROGRAM_URL}/${language}?${utmQueryString}`}
            tag="a"
            title={t('navigation:signInOrSignUp')}
            user="landlord"
            variant="secondary"
          >
            {t('navigation:signInOrSignUp')}
          </CtaButton>
        </div>
      </Grid>
    </StyledHeader>
  );
};

export default ReferALandlordHeader;
